import { useViewerAuth } from "./ViewerAuthContext";
import { resolveAdminSession } from "./adminSessionState";

export function useAdminSession() {
  const viewer = useViewerAuth();

  return resolveAdminSession({
    viewerUser: viewer.user,
    viewerLoading: viewer.loading,
    viewerLogout: viewer.logout,
  });
}
